import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const painPoints = [{
  icon: '😤',
  title: 'La masa queda dura',
  description: 'Amasas durante horas y el resultado parece cartón.'
}, {
  icon: '🔥',
  title: 'El horno no calienta',
  description: 'Crees que tu horno doméstico nunca logrará las temperaturas de una pizzería.'
}, {
  icon: '😞',
  title: 'La salsa sabe a lata',
  description: 'El sabor nunca llega al nivel de un restaurante italiano de verdad.'
}, {
  icon: '😰',
  title: 'La masa se rompe',
  description: 'Se agujerea o se encoge como si tuviera voluntad propia.'
}, {
  icon: '🍕',
  title: 'El borde no infla',
  description: 'Ese cornicione esponjoso parece imposible de lograr en casa.'
}, {
  icon: '💸',
  title: 'Gastas y no mejoras',
  description: 'Harinas caras, piedras de hornear y libros, pero el resultado sigue mediocre.'
}];
const pizzaImages = ['https://cdn.magicpatterns.com/uploads/rMR46tnZG74ok1E88JCUJY/19_Wood_Fired_Pizza_Ideas__Irresistible_Recipes_for_Authentic_Flavor_-_Recipes_Their.jpg', 'https://cdn.magicpatterns.com/uploads/9ifPNRn4peJVqbSJUvFRsD/descarga_(1).jpg', 'https://cdn.magicpatterns.com/uploads/w2Jg9haDk5zx7BPKiwFdVw/usa.jpg', 'https://cdn.magicpatterns.com/uploads/2mFvCh7fY9TucvhmY8WtLW/descarga.jpg'];
export function PainPoints() {
  const [currentImage, setCurrentImage] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % pizzaImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <div className="bg-[#111111] border-t border-b border-[#C0392B]/20 py-6 px-5" data-id="element-73">
      <div className="max-w-5xl mx-auto" data-id="element-74">
        <h2 className="font-serif text-xl sm:text-2xl md:text-3xl text-[#C0392B] text-center mb-1 uppercase tracking-wider" data-id="element-75">
          ¿Te Identificas con Esto?
        </h2>
        <div className="w-16 h-0.5 bg-gradient-to-r from-[#C0392B] to-[#F1C40F] mx-auto rounded my-2" data-id="element-76" />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mt-4" data-id="element-77">
          {painPoints.map((point, index) => <motion.div key={index} className="bg-[#1A1A1A] border border-[#C0392B]/30 border-l-3 border-l-[#C0392B] rounded-lg p-3 text-center" whileHover={{
          y: -3
        }} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} data-id="element-78">
              <span className="text-xl block mb-1" data-id="element-79">{point.icon}</span>
              <h3 className="text-[#F1C40F] text-[10px] font-bold uppercase tracking-wide mb-1 font-serif" data-id="element-80">
                {point.title}
              </h3>
              <p className="text-[#AAAAAA] text-[10px] leading-tight" data-id="element-81">
                {point.description}
              </p>
            </motion.div>)}
        </div>

        {/* Image Carousel */}
        <div className="mt-5 relative overflow-hidden rounded-xl border border-[#C0392B]/30 max-w-2xl mx-auto" data-id="element-82">
          <div className="relative w-full h-48 sm:h-64 md:h-80" data-id="element-83">
            <AnimatePresence mode="wait" data-id="element-84">
              <motion.img key={currentImage} src={pizzaImages[currentImage]} alt="Pizza artesanal" className="absolute inset-0 w-full h-full object-cover" initial={{
              opacity: 0,
              scale: 1.05
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.95
            }} transition={{
              duration: 0.6
            }} data-id="element-85" />
            </AnimatePresence>
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent z-10" data-id="element-86" />
          </div>
          {/* Dots */}
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 z-20 flex gap-2" data-id="element-87">
            {pizzaImages.map((_, i) => <button key={i} onClick={() => setCurrentImage(i)} className={`w-2 h-2 rounded-full transition-all duration-300 ${i === currentImage ? 'bg-[#F1C40F] w-4' : 'bg-white/50'}`} data-id="element-88" />)}
          </div>
        </div>

        {/* Solution merged here */}
        <div className="mt-5 text-center border-t border-[#C0392B]/10 pt-4" data-id="element-89">
          <p className="text-[#F1C40F] text-xs font-bold italic mb-2" data-id="element-90">
            No es tu culpa. Nadie te enseñó el método correcto. Hasta ahora.
          </p>
          <p className="text-xs sm:text-sm text-[#F5F5F5] max-w-2xl mx-auto leading-relaxed" data-id="element-91">
            Hemos creado el sistema más completo en español para dominar el arte
            de la pizza desde tu cocina. Sin hornos industriales. Sin
            ingredientes imposibles. Sin excusas.
          </p>
        </div>
      </div>
    </div>;
}